import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditDiscount = props => {
  const { discountId } = props.params

  return (
    <Edit
// @ts-ignore
      title='Edit Discount'
      fields={fields}
      apiPath={`admin/discounts/${discountId}`}
      successRedirectPath='/ecommerce/discounts'
      buildMenuItems={menuItems}
    />
  )
}

export default EditDiscount
